module.exports = __webpack_public_path__ + "static/media/allalerts_unread_hover.3cb8cd7f.svg";